import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "audit-div"
};
const _hoisted_2 = {
  class: "appr-content"
};
const _hoisted_3 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Check = _resolveComponent("Check");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_button = _resolveComponent("el-button");
  const _component_Close = _resolveComponent("Close");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createBlock(_component_el_dialog, {
    title: "领导审核",
    width: "30%",
    "show-close": false,
    "model-value": $props.visible,
    onClose: $setup.close
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_3, [_createVNode(_component_el_button, {
      onClick: $setup.close
    }, {
      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("取 消", -1)]))]),
      _: 1
    }, 8, ["onClick"]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      type: "primary",
      onClick: $setup.hanldeSubmit
    }, {
      default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("提 交", -1)]))]),
      _: 1
    }, 8, ["onClick"])), [[_directive_loading, _ctx.loading]])])]),
    default: _withCtx(() => [_cache[7] || (_cache[7] = _createElementVNode("div", {
      class: "title-div",
      style: {
        "margin-top": "10px"
      }
    }, "请选择审核结果", -1)), _createElementVNode("div", _hoisted_1, [_createVNode(_component_el_button, {
      class: "audit-button",
      type: "success",
      plain: _ctx.audit.approveState != 1,
      onClick: _cache[0] || (_cache[0] = $event => _ctx.audit.approveState = 1)
    }, {
      default: _withCtx(() => [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_Check)]),
        _: 1
      }), _cache[3] || (_cache[3] = _createTextVNode(" 通过 ", -1))]),
      _: 1
    }, 8, ["plain"]), _createVNode(_component_el_button, {
      class: "audit-button",
      type: "danger",
      plain: _ctx.audit.approveState != -1,
      onClick: _cache[1] || (_cache[1] = $event => _ctx.audit.approveState = -1)
    }, {
      default: _withCtx(() => [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_Close)]),
        _: 1
      }), _cache[4] || (_cache[4] = _createTextVNode(" 驳回 ", -1))]),
      _: 1
    }, 8, ["plain"])]), _cache[8] || (_cache[8] = _createElementVNode("div", {
      class: "title-div",
      style: {
        "margin-top": "10px"
      }
    }, "请输入审核备注内容", -1)), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
      type: "textarea",
      rows: 3,
      placeholder: "请输入审核备注内容",
      modelValue: _ctx.audit.aprroveContent,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.audit.aprroveContent = $event)
    }, null, 8, ["modelValue"])])]),
    _: 1
  }, 8, ["model-value", "onClose"]);
}